import { loginFormConstraints, LoginPageProps } from './login-page.types'
import { LoginPage as LoginPageUI } from '@touche-lts/panel-ui/dist'
import styles from './login-page.module.scss'
import React, { useState } from 'react'
import { LoginPayload } from 'services'
import validate from 'validate.js'
import { useRootStore } from 'mobx-stores/store-provider'
import ReCAPTCHA from 'react-google-recaptcha';
import { RE_CAPTCHA_SITE_KEY } from 'config/environment'

const LoginPageComponent = (props: LoginPageProps) => {
  const {
    userStore: { login, socialLogin, getGoogleAuthUrl, getMicrosoftAuthUrl, /* getAppleAuthUrl */ }
  } = useRootStore()

  const [formState, setFormState] = useState<LoginPayload>({
    emailAddress: '',
    password: '',
    rememberMe:false,
    reCaptchaToken:'',
  })

  const onLoginClick = () => {
    login(formState)
  }

  function handleRemember(rememberMe:boolean):void {
    setFormState({
      ...formState,
      rememberMe,
    });
  }
  function handleReCaptcha(token:string):void {
    setFormState({
      ...formState,
      reCaptchaToken:token
    })
  }

  const handleGoogleLogin = async () => {
    localStorage.setItem('oauth_provider', 'google')
    const data = await getGoogleAuthUrl('marketplace-admin')
    if (data?.url) {
      window.location.href = data.url
    }
  }

  const handleMicrosoftLogin = async () => {
    localStorage.setItem('oauth_provider', 'microsoft')
    const data = await getMicrosoftAuthUrl('marketplace-admin')
    if (data?.url) {
      window.location.href = data.url
    }
  }

  // const handleAppleLogin = async () => {
  //   localStorage.setItem('oauth_provider', 'apple')
  //   const data = await getAppleAuthUrl('marketplace-admin')
  //   if (data?.url) {
  //     window.location.href = data.url
  //   }
  // }

  // Handle OAuth callback
  React.useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.substring(1))
    const queryParams = new URLSearchParams(window.location.search)
    const idToken = hashParams.get('id_token') ?? queryParams.get('id_token')

    if (idToken) {
      const provider = localStorage.getItem('oauth_provider') || 'google'
      const oauthTarget = localStorage.getItem('oauth_target')

      // If token was initiated from the Shopify login page, hand it back there
      if (oauthTarget === 'shopify') {
        localStorage.removeItem('oauth_target')
        window.location.replace(
          `/shopify/login#id_token=${encodeURIComponent(idToken)}&provider=${encodeURIComponent(provider)}`
        )
        return
      }

      socialLogin(provider, idToken, 'marketplace-admin').then(() => {
        localStorage.removeItem('oauth_provider')
        window.history.replaceState(null, null, window.location.pathname)
      })
    }
  }, [socialLogin])

  return (
    <LoginPageUI
      style={{ backgroundColor: styles.primaryContent }}
      loginButtonProps={{
        children: 'Log in',
        onClick: onLoginClick,
        disabled: validate(formState, loginFormConstraints)
      }}
      emailAddressValue={formState.emailAddress}
      onEmailAddressChange={emailAddress =>
        setFormState(s => ({ ...s, emailAddress }))
      }
      passwordValue={formState.password}
      onPasswordChange={password => setFormState(s => ({ ...s, password }))}
      onRememberChange={handleRemember}
      onGoogleLogin={handleGoogleLogin}
      onMicrosoftLogin={handleMicrosoftLogin}
      // onAppleLogin={handleAppleLogin}
      ReCaptchaComponent={ 
      <div className='my-3 me-auto'>
        <ReCAPTCHA
          sitekey={RE_CAPTCHA_SITE_KEY}
          onChange={handleReCaptcha}
          theme="light"
        />
      </div>
      }
    />
  )
}

const LoginPage = LoginPageComponent
export { LoginPage }
